/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  bulkMove(data) {
    return axios.post(`${this.url}/bulk_move`, data);
  }
  
  toggleActivation(agentIds, active) {
    return axios.post(`${this.url}/bulk_toggle_active`, {
      agent_ids: agentIds,
      active: active
    });
  }
}

export default new Agents();
